const addFormikData = (data, newFields = null, addOnExisitngField = null) => {
    
    if(addOnExisitngField) {
        data[addOnExisitngField] = newFields
    } else if(newFields) {
        data[newFields] = null
    }

    return data
}

export default addFormikData